import React from "react";

const HORECA: React.FC = () => {
  return (
    <main className="min-h-screen w-full bg-gray-100">
      <div className="w-full mx-auto px-6 py-20 max-w-full">
        {/* HORECA Background Banner with centered text overlay */}
        <div className="w-full mb-12 relative flex items-center justify-center">
          <img
            src={`${process.env.PUBLIC_URL}/images/horecabg.jpeg`}
            alt="HORECA Background"
            className="w-full h-40 object-cover rounded-lg"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-lg md:text-2xl font-semibold text-center text-[#0f145b]">
              World Renowned brands that cater to the Professional sector needs.
            </span>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-10 w-full max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl mx-auto mt-24 mb-16">
          <div className="rounded-lg overflow-hidden flex flex-col items-center">
            <a
              href="https://inimexshop.com/en/collections/kleenex"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/kimberly.svg`}
                alt="HORECA Brand"
                className="w-full h-40 object-contain hover:opacity-80 transition"
              />
            </a>
          </div>
        </div>

        {/* HORECA Filler full-width responsive image */}
        <div className="w-full mt-12" style={{ marginBottom: 0 }}>
          <picture>
            <source
              media="(min-width: 1024px)"
              srcSet={`${process.env.PUBLIC_URL}/images/horecalaptop.jpeg`}
            />
            <source
              media="(min-width: 640px)"
              srcSet={`${process.env.PUBLIC_URL}/images/Horecatablet.jpeg`}
            />
            <img
              src={`${process.env.PUBLIC_URL}/images/Horecamobile.jpeg`}
              alt="HORECA Filler"
              className="w-full h-[30rem] object-contain bg-white"
              style={{ objectPosition: "center" }}
            />
          </picture>
        </div>
      </div>
    </main>
  );
};

export default HORECA;
